"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var feature_flipper_1 = require("@shared/constants/feature-flipper");
var environment_1 = require("@shared/types/environment");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('prPageHeaderFooterGenerator', [
        '$sanitize',
        'rsEnvironment',
        'prPageLayoutService',
        'prTextFormatsHelper',
        'pr.timezoneUtil',
        'pr.globalOptionsService',
        function (
        // @ts-ignore
        $sanitize, env, pageLayout, 
        // @ts-ignore
        formatHelper, 
        // @ts-ignore
        timezoneUtil, 
        // @ts-ignore
        goService) {
            var HeaderFooterOptions;
            (function (HeaderFooterOptions) {
                HeaderFooterOptions["LOGO"] = "logo";
                HeaderFooterOptions["CUSTOM_TITLE"] = "customTitle";
                HeaderFooterOptions["PAGE_NUMBER"] = "pageNumber";
                HeaderFooterOptions["TIMEZONE"] = "timezone";
                HeaderFooterOptions["NONE"] = "none";
                HeaderFooterOptions["LEFT"] = "left";
                HeaderFooterOptions["CENTER"] = "center";
                HeaderFooterOptions["RIGHT"] = "right";
                HeaderFooterOptions["PAGE_VARIABLE"] = "{{__page__}}";
                HeaderFooterOptions["QUILL_DELTA"] = "quillObject";
            })(HeaderFooterOptions || (HeaderFooterOptions = {}));
            var COMPONENTS_PRIORITY_ORDER = [
                HeaderFooterOptions.LOGO,
                HeaderFooterOptions.CUSTOM_TITLE,
                HeaderFooterOptions.TIMEZONE,
                HeaderFooterOptions.PAGE_NUMBER
            ];
            var PX_TO_IN = pageLayout.PX_TO_IN;
            var options;
            function getHeaderFooterHTML(headerFooterOptions) {
                options = headerFooterOptions;
                var alignmentGroups = getAlignmentGroups();
                var visitedComps = {};
                var lp = 0;
                var rp = 0;
                var tableHtml = '';
                lodash_1.default.forEach(COMPONENTS_PRIORITY_ORDER, function (component) {
                    // @ts-ignore
                    var align = options[component].alignment;
                    // @ts-ignore
                    if (align === HeaderFooterOptions.NONE || visitedComps[component]) {
                        return;
                    }
                    if (align === HeaderFooterOptions.LEFT) {
                        if (rp < alignmentGroups.right.length) {
                            var rightComp = alignmentGroups.right[rp];
                            tableHtml += getRowOfTwoComps(component, rightComp);
                            // @ts-ignore
                            visitedComps[rightComp] = true;
                            rp++;
                        }
                        else {
                            tableHtml += getRowOfSingleComp(component);
                        }
                        lp++;
                    }
                    else if (align === HeaderFooterOptions.CENTER) {
                        tableHtml += getRowOfSingleComp(component);
                    }
                    else if (align === HeaderFooterOptions.RIGHT) {
                        if (lp < alignmentGroups.left.length) {
                            var leftComp = alignmentGroups.left[lp];
                            tableHtml += getRowOfTwoComps(leftComp, component);
                            // @ts-ignore
                            visitedComps[leftComp] = true;
                            lp++;
                        }
                        else {
                            tableHtml += getRowOfSingleComp(component);
                        }
                        rp++;
                    }
                    // @ts-ignore
                    visitedComps[component] = true;
                });
                tableHtml = tableHtml.length === 0 ? '' : '<table>' + tableHtml + '</table>';
                return tableHtml;
            }
            function getRowOfSingleComp(component) {
                var tableCell = getTableCell(component);
                if (!tableCell) {
                    return '';
                }
                var htmlStr = '<tr>' + tableCell + '</tr>';
                return lodash_1.default.replace(htmlStr, '<td', '<td colspan="2"');
            }
            function getRowOfTwoComps(leftComp, rightComp) {
                return '' +
                    '<tr>' +
                    getTableCell(leftComp) +
                    getTableCell(rightComp) +
                    '</tr>';
            }
            // @ts-ignore
            function getTableCell(component) {
                switch (component) {
                    case HeaderFooterOptions.LOGO:
                        return getLogoCell();
                    case HeaderFooterOptions.CUSTOM_TITLE:
                        return getTitleCell();
                    case HeaderFooterOptions.PAGE_NUMBER:
                        return getPageNumCell();
                    case HeaderFooterOptions.TIMEZONE:
                        return getTimezoneCell();
                }
            }
            function getLogoCell() {
                var logoObj = options[HeaderFooterOptions.LOGO];
                var logoURL = logoObj.type === 'CUSTOM' ? logoObj.customUrl : env.get(environment_1.ENV_VARS.BRAND_LOGO);
                var logoStyle = 'height: ' + logoObj.height * PX_TO_IN + 'px; text-align: ' + logoObj.alignment;
                var content = '<img src="' + logoURL + '" class="logo">';
                return '<td style="' + logoStyle + '">' + $sanitize(content) + '</td>';
            }
            /**
             * Creates an HTML string using the quillObject operations and combining that
             * with format derived from the text-format-helper service.
             *
             * This is an EXTREMELY hacky way create HTML that renders what is supposed to be
             * inside the quill editor.
             *
             * When using dynamic translations, we serialize the quillObjectHtml and export that into the CSV.
             * When importing, we unserialize this, re-fetch the latest translated piped text values,
             * and convert it to the quillObj used here.
             */
            function getTitleCell() {
                var titleObj = options[HeaderFooterOptions.CUSTOM_TITLE];
                var titleStyle = formatHelper.getStyles(titleObj.formats, true).replace(/"/g, '\'');
                var featureFlipper = env.get(environment_1.ENV_VARS.FEATURES) || {};
                if (featureFlipper[feature_flipper_1.FEATURES.HEADER_FOOTER_PIPED_TEXT]) {
                    // This contains the un-serialized and dynamically translated quill delta
                    var quillDelta = options[HeaderFooterOptions.QUILL_DELTA];
                    var contentHtml = "\n\t\t\t\t\t\t<div style=\"" + titleStyle + "\">\n\t\t\t\t\t\t\t" + getContentFromQuillDelta(quillDelta.ops) + "\n\t\t\t\t\t\t</div>\n\t\t\t\t\t";
                    return buildTd(titleObj.alignment, contentHtml);
                }
                else {
                    convertCustomTitleToQuillDelta(titleObj);
                }
                if (!titleObj.content) {
                    return '';
                }
                var content = '<div class="title" style="' + titleStyle + '">' + $sanitize(titleObj.content)
                    + '</div>';
                return buildTd(titleObj.alignment, content);
            }
            function convertCustomTitleToQuillDelta(titleObj) {
                var quillDelta = {
                    ops: [
                        {
                            insert: titleObj.content
                        }
                    ]
                };
                options[HeaderFooterOptions.QUILL_DELTA] = quillDelta;
            }
            /**
             * Extracts content from a quill delta and converts it to a string.
             */
            function getContentFromQuillDelta(ops) {
                var content = '';
                lodash_1.default.forEach(ops, function (op) {
                    // @ts-ignore
                    if (op.insert['piped-text']) {
                        // @ts-ignore
                        content += op.insert['piped-text'].ptAttrs.innerText;
                    }
                    else {
                        content += op.insert;
                    }
                });
                content = $sanitize(content);
                return content;
            }
            function getPageNumCell() {
                var pageNumObj = options[HeaderFooterOptions.PAGE_NUMBER];
                var content = '<div class="page-number pr-body-style">' + HeaderFooterOptions.PAGE_VARIABLE
                    + '</div>';
                return buildTd(pageNumObj.alignment, content);
            }
            function getTimezoneCell() {
                // @ts-ignore
                var timezoneObj = options[HeaderFooterOptions.TIMEZONE];
                var content = '<div class="timezone pr-body-style">' + getTimezoneLabel() + '</div>';
                return buildTd(timezoneObj.alignment, content);
            }
            function getTimezoneLabel() {
                return timezoneUtil.getTimezoneLabel(goService.getOptions().timezone || timezoneUtil.getGuessTimezone());
            }
            function buildTd(align, contents) {
                return '<td style="text-align: ' + align + '">' + contents + '</td>';
            }
            function getAlignmentGroups() {
                var group = {
                    left: [],
                    center: [],
                    right: []
                };
                lodash_1.default.forEach(COMPONENTS_PRIORITY_ORDER, function (comp) {
                    // @ts-ignore
                    var compObj = options[comp];
                    // @ts-ignore
                    if (compObj && compObj.alignment && group[compObj.alignment]) {
                        // @ts-ignore
                        group[compObj.alignment].push(comp);
                    }
                });
                return group;
            }
            return {
                getHeaderFooterHTML: getHeaderFooterHTML,
                getContentFromQuillDelta: getContentFromQuillDelta,
                convertCustomTitleToQuillDelta: convertCustomTitleToQuillDelta
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
